import { CHIPS_COLORS } from './colors';
import { ChipType } from '../types';

export const CHIPS_MIN_50k: ChipType[] = [
  {
    color: CHIPS_COLORS.BROWN,
    value: 10e3,
  },
  {
    color: CHIPS_COLORS.BLUE,
    value: 50e3,
  },
  {
    color: CHIPS_COLORS.YELLOW,
    value: 100e3,
  },
  {
    color: CHIPS_COLORS.RED,
    value: 200e3,
  },
  {
    color: CHIPS_COLORS.VIOLET,
    value: 500e3,
  },
  {
    color: CHIPS_COLORS.GREEN,
    value: 1e6,
  },
  {
    color: CHIPS_COLORS.ORANGE,
    value: 2e6,
  },
  {
    color: CHIPS_COLORS.LIGHT_BLUE,
    value: 5e6,
  },
  {
    color: CHIPS_COLORS.SCARLET,
    value: 10e6,
  },
];
